"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M11 15.542V20H9v-4.458L2 17l4.5-5.625L4 12l3.655-5.483L6 7l4-7 4 7-1.655-.483L16 12l-2.5-.625L18 17l-7-1.458z"];
//# sourceMappingURL=tree.js.map